import useRejectReturnRequest from "@babackapp/private-api-client/client/use-reject-return-request";
import { useCurrentReturnRequest } from "../../../utils/current-return-request-context";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useLineItemRejectReasons } from "../../../refund/hooks/use-line-item-reject-reason";
import { useRejectLineItems } from "../../../refund/hooks/use-reject-line-items-context";
import useRejectLineItemsState from "../../../refund/hooks/use-reject-line-items-state-context";
import { useLineItemsLoadingState } from "../../../utils/line-items-loading-state-context";

type AcceptReturnRequestParams = {
  onSuccess: () => void;
  onMutate: () => void;
  onError: () => void;
};
export const useSumbitRejectReturnRequest = ({
  onSuccess,
  onMutate,
  onError,
}: AcceptReturnRequestParams) => {
  const { data: shop } = useCurrentShopSuspense();
  const { mutate: rejectReturnRequest } = useRejectReturnRequest({
    shopId: shop.id,
    onMutate,
    onSuccess,
    onError,
  });
  const currentReturnRequest = useCurrentReturnRequest();
  const { items: lineItems } = useRejectLineItems();
  const { lineItemsState } = useRejectLineItemsState();
  const { lineItemsReason } = useLineItemRejectReasons();
  const { setState: setLoadingState } = useLineItemsLoadingState();

  /**
   * Update line items loading state before and after the mutation.
   */
  const setAcceptedLineItemsLoadingState = (
    items: { lineItemId: string }[],
    value: boolean,
  ) => {
    setLoadingState((prev) =>
      items.reduce(
        (acc, item) => {
          acc[item.lineItemId] = value;
          return acc;
        },
        { ...prev },
      ),
    );
  };

  return function submit() {
    const acceptedLineItems = lineItems
      .filter((lineItem) => !!lineItem.resolution && lineItemsState[lineItem.line_item_id]?.total.selectedQuantity > 0)
      .map((lineItem) => ({
        lineItemId: lineItem.line_item_id,
        quantity: lineItemsState[lineItem.line_item_id]?.total.selectedQuantity,
        reason: lineItemsReason[lineItem.line_item_id]
          ? lineItemsReason[lineItem.line_item_id].reason
          : "",
      }));
    setAcceptedLineItemsLoadingState(acceptedLineItems, true);

    rejectReturnRequest(
      {
        variables: {
          lineItemsToHandle: acceptedLineItems,
        },

        returnRequestId: currentReturnRequest.id,
      },
      {
        onSettled: () =>
          setAcceptedLineItemsLoadingState(acceptedLineItems, false),
      },
    );
  };
};
